{
  "common": {
    "memberCenter": "ศูนย์สมาชิก",
    "points": "คะแนน",
    "level": "ระดับ",
    "coupons": "คูปอง",
    "checkin": "เช็คอิน",
    "history": "ประวัติ",
    "balance": "ยอดคงเหลือ",
    "expire": "หมดอายุ",
    "confirm": "ยืนยัน",
    "cancel": "ยกเลิก",
    "loading": "กำลังโหลด...",
    "noData": "ไม่มีข้อมูล",
    "retry": "ลองอีกครั้ง",
    "success": "สำเร็จ",
    "failed": "ล้มเหลว"
  },
  "points": {
    "earn": "ได้รับ {amount} คะแนน",
    "spend": "ใช้ {amount} คะแนน",
    "balance": "ยอดคงเหลือปัจจุบัน: {amount} คะแนน",
    "expired": "{amount} คะแนนหมดอายุแล้ว",
    "estimated": "ประมาณการ (รอการยืนยัน)"
  },
  "level": {
    "current": "ระดับปัจจุบัน: {name}",
    "nextLevel": "ระดับถัดไป: {name}",
    "progress": "{current}/{target} สู่ระดับถัดไป",
    "upgraded": "ยินดีด้วย! เลื่อนระดับเป็น {name}"
  },
  "coupon": {
    "claim": "รับ",
    "claimed": "รับแล้ว",
    "expired": "หมดอายุ",
    "used": "ใช้แล้ว",
    "validUntil": "ใช้ได้ถึง {date}"
  },
  "checkin": {
    "today": "เช็คอินวันนี้",
    "done": "เช็คอินแล้ว",
    "streak": "เช็คอินติดต่อกัน {days} วัน",
    "reward": "+{amount} คะแนน"
  },
  "errors": {
    "network": "เกิดข้อผิดพลาดเครือข่าย กรุณาลองอีกครั้ง",
    "unauthorized": "กรุณาเข้าสู่ระบบ",
    "serverError": "เกิดข้อผิดพลาดเซิร์ฟเวอร์ กรุณาลองอีกครั้งในภายหลัง",
    "timeout": "คำขอหมดเวลา"
  },
  "ui": {
    "memberCenter": {
      "loading": "กำลังโหลด...",
      "avatarAlt": "รูปสมาชิก",
      "pointsBalance": "คะแนนของฉัน",
      "menuLabel": "เมนูสมาชิก",
      "menu": {
        "pointsDetail": "ประวัติคะแนน",
        "levelDetail": "สิทธิประโยชน์ระดับ",
        "coupons": "คูปองของฉัน",
        "referral": "เชิญเพื่อน",
        "checkin": "เช็คอินรายวัน"
      }
    },
    "pointsDetail": {
      "title": "ประวัติคะแนน",
      "empty": "ไม่มีประวัติคะแนน",
      "loading": "กำลังโหลด...",
      "noMore": "ไม่มีรายการเพิ่มเติม",
      "listLabel": "รายการคะแนน",
      "status": {
        "pending": "รอดำเนินการ",
        "active": "ใช้งานได้",
        "used": "ใช้แล้ว",
        "expired": "หมดอายุ"
      }
    },
    "levelProgress": {
      "loading": "กำลังโหลด...",
      "maxLevel": "ระดับสูงสุดแล้ว",
      "progressLabel": "ความคืบหน้าระดับ",
      "noBenefits": "ยังไม่มีสิทธิประโยชน์",
      "nextLevel": "ระดับถัดไป: {name}",
      "benefitsTitle": "สิทธิประโยชน์ของฉัน"
    },
    "couponList": {
      "title": "คูปองของฉัน",
      "tabsLabel": "หมวดหมู่คูปอง",
      "listLabel": "รายการคูปอง",
      "empty": "ไม่มีคูปอง",
      "freeShipping": "ส่งฟรี",
      "giftValue": "ของขวัญ",
      "discountValue": "ลด {value}%",
      "type": {
        "discount": "ส่วนลด",
        "cash": "เงินสด",
        "shipping": "ค่าจัดส่ง",
        "gift": "ของขวัญ"
      },
      "tab": {
        "available": "ใช้ได้",
        "used": "ใช้แล้ว",
        "expired": "หมดอายุ"
      }
    },
    "referralShare": {
      "loading": "กำลังโหลด...",
      "title": "เชิญเพื่อน",
      "shareTitle": "เชิญบคะแนน",
      "shareText": "สมัครเลยและรับของขวัญฟรี!",
      "invitedCount": "เชิญแล้ว",
      "rewardPoints": "คะแนนที่ได้รับ",
      "codeLabel": "รหัสเชิญของฉัน",
      "linkLabel": "ลิงก์เชิญ",
      "copy": "คัดลอก",
      "copyCode": "คัดลอกรหัสเชิญ",
      "share": "แชร์",
      "rewardHint": "รับ {points} คะแนนต่อเพื่อนหนึ่งคน"
    },
    "checkinCalendar": {
      "loading": "กำลังโหลด...",
      "checking": "กำลังเช็คอิน...",
      "checkin": "เช็คอิน",
      "alreadyChecked": "เช็คอินแล้ววันนี้",
      "day": "{count} วัน",
      "title": "เช็คอินรายวัน",
      "streak": "เช็คอินติดต่อกัน {days} วัน",
      "calendarLabel": "ปฏิทินเช็คอิน",
      "rewardsTitle": "รางวัลต่อเนื่อง",
      "rewardsLabel": "รายการรางวัล",
      "weekday": {
        "sun": "อา",
        "mon": "จ",
        "tue": "อ",
        "wed": "พ",
        "thu": "พฤ",
        "fri": "ศ",
        "sat": "ส"
      }
    },
    "auth": {
      "login": {
        "emailLabel": "อีเมล",
        "passwordLabel": "รหัสผ่าน",
        "submit": "เข้าสู่ระบบ",
        "createAccount": "สร้างบัญชี",
        "forgotPassword": "ลืมรหัสผ่าน?",
        "orDivider": "หรือ"
      },
      "register": {
        "emailLabel": "อีเมล",
        "passwordLabel": "รหัสผ่าน",
        "confirmPasswordLabel": "ยืนยันรหัสผ่าน",
        "passwordHint": "อย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรและตัวเลข",
        "submit": "สร้างบัญชี",
        "hasAccount": "มีบัญชีแล้ว? เข้าสู่ระบบ",
        "passwordMismatch": "รหัสผ่านไม่ตรงกัน"
      },
      "oauth": {
        "continueWith": "ดำเนินการต่อด้วย {provider}"
      },
      "verify": {
        "resend": "ส่งรหัสอีกครั้ง",
        "resendCountdown": "ส่งอีกครั้ง ({countdown} วินาที)"
      },
      "forgot": {
        "title": "รีเซ็ตรหัสผ่าน",
        "description": "กรอกอีเมลของคุณ แล้วเราจะส่งรหัสยืนยันให้คุณ",
        "emailLabel": "อีเมล",
        "submit": "ส่งรหัส",
        "backToLogin": "กลับไปเข้าสู่ระบบ"
      }
    }
  },
  "sdk": {
    "error": {
      "211001": "ตรวจสอบลายเซ็น webhook ล้มเหลว",
      "211003": "คำขอ webhook ซ้ำ",
      "211005": "ข้อมูลรับรองแพลตฟอร์มหมดอายุ",
      "211900": "การดำเนินการล้มเหลว กรุณาลองอีกครั้ง",
      "211903": "พารามิเตอร์คำขอไม่ถูกต้อง",
      "211909": "กรุณาเข้่ระบบหรือรีเฟรชเซสชัน",
      "211910": "การเข้าถึงถูกปฏิเสธ",
      "211911": "ไม่พบข้อมูลสมาชิก",
      "211912": "ตัวตนขัดแย้ง กรุณาติดต่อฝ่ายบริการ",
      "211931": "การตั้งค่าระดับผิดพลาด",
      "211933": "สิทธิประโยชน์ระดับไม่พร้อมใช้งาน",
      "211951": "ยอดคะแนนไม่เพียงพอ",
      "211952": "บัญชีคะแนนผิดพลาด กรุณาติดต่อฝ่ายบริการ",
      "211955": "ไม่ได้ตั้งค่ากฎการรับคะแนน",
      "211956": "หักคะแนนล้มเหลว",
      "211957": "คะแนนหมดอายุ",
      "211958": "ธุรกรรมคะแนนขัดแย้ง กรุณาลองอีกครั้ง",
      "211971": "คูปองไม่พร้อมใช้งาน",
      "211973": "คูปองถูกรับไปแล้ว",
      "211975": "คูปองหมดอายุ",
      "211976": "คูปองถูกใช้ไปแล้ว",
      "211991": "บริการยุ่ง กรุณาลองอีกครั้งในภายหลัง",
      "network": "ข้อผิดพลาดเครือข่าย กรุณาตรวจสอบการเชื่อมต่อ",
      "timeout": "คำขอหมดเวลา กรุณาลองอีกครั้ง",
      "aborted": "คำขอถูกยกเลิก",
      "parse": "ข้อผิดพลาดในการแยกวิเคราะห์การตอบกลับ",
      "unauthorized": "กรุณาเข้าสู่ระบบ",
      "config": "ข้อผิดพลาดในการเริ่มต้น SDK",
      "unknown": "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ"
    }
  }
}
